var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"shrink mr-2",attrs:{"src":require('../assets/logo.png'),"alt":"Vuetify Logo","contain":"","transition":"scale-transition","width":"40"}})}
var staticRenderFns = []

export { render, staticRenderFns }